import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { State } from '@feature/_app_modules/arrears-listing-widget/reducers/arrears-listing-widget.reducers';
import * as arrearsListingWidgetSelectors from '@feature/_app_modules/arrears-listing-widget/selectors/arrears-listing-widget.selectors';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { WidgetAndConfigId } from '@common/models/widget-and-config-id';
import * as filterSelectors from '@common/filter/selectors/filter.selectors';
import { Observable } from 'rxjs';
import { Currency } from '@currency/models/currency.model';

@Injectable({
  providedIn: 'root'
})
export class ArrearsListingWidgetFacadeService {

  constructor(
    private readonly store: Store<State>
  ) {
  }

  widgetLoading(widget: WidgetAndConfigId) {
    return this.store.pipe(select(arrearsListingWidgetSelectors.getWidgetLoading(widget.id))).pipe(distinctUntilChanged());
  }

  arrearsTable(widget: WidgetAndConfigId, currencyCode: string) {
    return this.store.pipe(
      select(arrearsListingWidgetSelectors.tableFilteredByCurrency(widget.id, currencyCode)),
      filter(d => d != undefined),
      distinctUntilChanged()
    );
  }


  outstandingAmountTotal(widget: WidgetAndConfigId, currencyCode: string) {
    return this.store.pipe(select(arrearsListingWidgetSelectors.outstandingAmountTotal(widget.id, currencyCode)));
  }

  userFilter(widget: WidgetAndConfigId) {
    return this.store.pipe(select(filterSelectors.getWidgetFilter(widget.id))).pipe(distinctUntilChanged());;
  }

  currency(widget: WidgetAndConfigId) {
    return this.store.pipe(select(arrearsListingWidgetSelectors.getCurrency(widget.id)));
  }

  availableCurrencies(widget: WidgetAndConfigId) {
    return this.store.pipe(select(arrearsListingWidgetSelectors.distinctCurrenciesFromTableData(widget.id)));
  }

  arrearsAsAtDate(widget: WidgetAndConfigId) {
    return this.store.pipe(select(arrearsListingWidgetSelectors.asAtDate(widget.id)));
  }

}
